export default "__VITE_ASSET__6skHRcNB__"